import { render, staticRenderFns } from "./Nationalities.vue?vue&type=template&id=4ca70bc7"
import script from "./Nationalities.vue?vue&type=script&lang=js"
export * from "./Nationalities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports